import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const MessungDesErfolgsAbschlussKreativ: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Messung des Erfolgs' description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default MessungDesErfolgsAbschlussKreativ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0104180622_ie_Ggf_Nicht_Erreicht_Werden,
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0105029854_ie_Ggf_Nicht_Erreicht_Werden,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucMessungDesErfolgsAbschlussKreativ = () => {
	return concat(formStruc());
};
